import { IBillingInitialState } from "../../../types/master/billingInterface";
import { BillingActionTypes, BillingActions } from "../../actionTypes/master/billingActionTypes";

const emptyBillingData: IBillingInitialState["billingData"] = {
  id: 0,
  awb_id: 0,
  customer_id: 0,
  service_mode: "",
  origin_zone: "",
  destination_zone: "",
  rate_source: "",
  rate_per_kg: "",
  total_actual_weight: "",
  total_volumetric_weight: "",
  chargeable_weight: "",
  basic_freight: "",
  hard_copy_pod: "",
  carrier_risk: "",
  demurrage_charges: "",
  sunday_holiday_delivery_charges: "",
  floor_delivery: "",
  appointment: "",
  cod_charge: "",
  to_pay_charge: "",
  package_handling_charge: "",
  fuel_surcharge: "",
  owner_risk: "",
  docket_charge: "",
  oda_3: "",
  oda_2: "",
  oda_1: "",
  total_vas: "",
  total_amount: "",
  cgst_rate: "",
  sgst_rate: "",
  cgst_amount: "",
  sgst_amount: "",
  total_gst: "",
  grand_total: "",
  billing_date: "",
  invoice_number: null,
  payment_status: "",
  billing_qc_status: "",
  billing_qc_by: null,
  billing_qc_remarks: null,
  remarks: null,
  created_by: 0,
  awb: null,
  customer: null,
};

const initialState: IBillingInitialState = {
  billingList: [],
  billingListPageCount: 0,
  generatedBilling: null,
  billingData: emptyBillingData,
  lastListQuery: null,
  billingHistoryList: [],
  billingHistoryPageCount: 0,
  billingHistoryDetail: null,
  billingHistoryDetailStatus: "idle",
};

export default function billingReducer(
  state = initialState,
  action: BillingActionTypes
): IBillingInitialState {
  switch (action.type) {
    case BillingActions.GET_BILLING_LIST:
      return {
        ...state,
        lastListQuery: action.payload,
      };

    case BillingActions.SET_BILLING_LIST:
      return {
        ...state,
        billingList: action.payload,
      };

    case BillingActions.SET_BILLING_LIST_PAGE_COUNT:
      return {
        ...state,
        billingListPageCount: action.payload,
      };

    case BillingActions.SET_GENERATED_BILLING:
      return {
        ...state,
        generatedBilling: action.payload,
      };

    case BillingActions.SET_BILLING_DATA_BY_ID:
      return {
        ...state,
        billingData: action.payload,
      };

    case BillingActions.SET_BILLING_HISTORY:
      return {
        ...state,
        billingHistoryList: action.payload,
      };

    case BillingActions.SET_BILLING_HISTORY_PAGE_COUNT:
      return {
        ...state,
        billingHistoryPageCount: action.payload,
      };

    case BillingActions.GET_BILLING_HISTORY_BY_ID:
      return {
        ...state,
        billingHistoryDetail: null,
        billingHistoryDetailStatus: "loading",
      };

    case BillingActions.SET_BILLING_HISTORY_BY_ID:
      return {
        ...state,
        billingHistoryDetail: action.payload,
        billingHistoryDetailStatus: action.payload ? "success" : "error",
      };

    case BillingActions.CLEAR_BILLING_HISTORY_BY_ID:
      return {
        ...state,
        billingHistoryDetail: null,
        billingHistoryDetailStatus: "idle",
      };

    default:
      return state;
  }
}
